import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { money } from "@/lib/api";
import PortalLayout from "@/components/portal/PortalLayout";
import StatusBadge from "@/components/StatusBadge";

export default function PortalRequests() {
  const [requests, setRequests] = useState([]);
  useEffect(() => { api.get("/my/requests").then((r) => setRequests(r.data)).catch(() => {}); }, []);
  return (
    <PortalLayout title="My Requests">
      {requests.length === 0 ? (
        <div className="rounded-xl border border-dashed border-border p-12 text-center text-muted-foreground">No requests yet. <Link to="/products" className="font-semibold text-primary">Apply for a product</Link>.</div>
      ) : (
        <div className="grid gap-3">
          {requests.map((r) => (
            <div key={r.id} className="flex flex-col gap-3 rounded-xl border border-border bg-card p-4 sm:flex-row sm:items-center" data-testid={`request-row-${r.id}`}>
              <img src={r.product_image} alt={r.product_name} className="h-14 w-14 rounded-lg object-cover" />
              <div className="flex-1"><p className="font-semibold">{r.product_name}</p><p className="text-xs text-muted-foreground">{r.request_no} · {r.plan_name} · {money(r.monthly_installment)}/mo</p>
                {(r.staff_notes || []).filter((n) => n.type === "objection").slice(-1).map((n, i) => <p key={i} className="mt-1 text-xs text-orange-600 dark:text-orange-400">Objection: {n.text}</p>)}
              </div>
              <StatusBadge status={r.status} />
            </div>
          ))}
        </div>
      )}
    </PortalLayout>
  );
}
